import type Transition from '@ember/routing/transition';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

export default class AiMessagingRoute extends ProtectedRoute {
  async beforeModel(transition: Transition): Promise<void> {
    const targetRoute = transition.to?.name;
    const queryParams = transition.to?.queryParams;

    if (targetRoute?.includes('content-files')) {
      this.router.replaceWith('automate.ai.content-files', { queryParams });
    } else {
      this.router.replaceWith('automate.ai.knowledge-center', { queryParams });
    }
  }
}
